import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UiEventRaised } from '@cmx/shared/feature/platform-configuration';
import { Axis, Dimensions, Legend, MultiSeriesData } from '../charts.model';
import { FieldType } from '@ngx-formly/core';
@Component({
  selector: 'cmx-heat-map-chart',
  templateUrl: './heat-map-chart.component.html',
  styleUrls: ['./heat-map-chart.component.scss'],
})
export class HeatMapChartComponent extends FieldType implements OnInit {
  @Input() data: MultiSeriesData[] = [];

  @Input() dimensions: Dimensions = { width: '', height: '' };
  @Input() allowResize = false;
  @Input() axis: Axis = {
    showXAxis: true,
    showYAxis: true,
    xAxisLabel: 'xAxis',
    yAxisLabel: 'yAxis',
    showXAxisLabel: true,
    showYAxisLabel: false,
  };
  @Input() legend: Legend = {
    visible: true,
    title: 'Legend',
    position: 'right' || 'below',
  };
  @Input() enableAnimations = true;
  @Input() tooltipDisabled = false;
  @Input() itemColor: string[] = [];
  @Input() isFormlyField = true;

  @Output() raiseHeatMapChartEvent = new EventEmitter<UiEventRaised>();

  colorScheme = { domain: [] };
  view: [number, number] = [500, 300];

  constructor(private element: ElementRef) {
    super();
  }

  ngOnInit() {
    if (this.isFormlyField) {
      this.data = this.to.data || this.data;
      this.allowResize = this.to.allowResize || this.allowResize;

      this.dimensions = this.to.dimensions || this.dimensions;
      this.axis = this.to.axis || this.axis;
      this.legend = this.to.legend || this.legend;
      this.enableAnimations = this.to.enableAnimations || this.enableAnimations;
      this.tooltipDisabled = this.to.tooltipDisabled || this.tooltipDisabled;
      this.itemColor = this.to.itemColor || this.itemColor;
    }
    this.resize(this.dimensions.width, this.dimensions.height);
  }

  onSelect(data: unknown): void {
    this.raiseEvent('heat-map-chart-clicked', data, false);
  }

  raiseEvent(eventName: string, data: unknown, isNavigation: boolean): void {
    const eventToRaise: UiEventRaised = { eventName, data, isNavigation };
    if (this.isFormlyField) {
      this.to.getFieldEvent(eventToRaise);
    } else {
      this.raiseHeatMapChartEvent.emit(eventToRaise);
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.resize(undefined, this.dimensions.height);
  }

  resize(width?: string | number, height?: string | number, timeout = 0) {
    setTimeout(() => {
      const parentElement = this.element.nativeElement.parentElement.parentElement;
      if (parentElement) {
        this.view = [+(width || parentElement.offsetWidth - 60), +(height || parentElement.offsetHeight - 60)];
      }
    }, timeout);
  }
}
